import { useAccount, useReadContract } from 'wagmi'
import { operatorAbi } from '@/abi/operatorAbi'
import { getContractAddress } from '@/config/contracts'
import { roleId } from '@/config/onchain-roles'

const OPERATOR_ROLE = roleId('OPERATOR_ROLE')

// Does the connected wallet hold OPERATOR_ROLE on this chain's BlockpotOperator?
// Distinct from the session's `rolesByChain`, which probes PlayerRegistry.
export function useBlockpotOperatorRole(chainId: number | null) {
    const { address } = useAccount()
    const operator = chainId === null ? undefined : getContractAddress(chainId, 'operator')
    const enabled = Boolean(operator) && Boolean(address)

    const query = useReadContract({
        address: operator,
        abi: operatorAbi,
        functionName: 'hasRole',
        args: enabled ? [OPERATOR_ROLE, address!] : undefined,
        chainId: chainId ?? undefined,
        query: { enabled },
    })

    return {
        hasOperatorRole: query.data === true,
        isLoading: enabled && query.isLoading,
    }
}
